import { Injectable } from '@angular/core';
import { MockedVicarePlans } from '@vi-iot/client/apis/purchases/purchases.mocks';
import { Observable, of } from 'rxjs';
import { SubscriptionWithPaidFeatures, PaidFeatureScope } from '../monetization/monetization.model';
import { PurchasesApiModel, ViCarePlan } from './purchases.model';
import { DemoSettingsStore } from '../../../../app/@store/demo-settings/demo-settings.store';

@Injectable({ providedIn: 'root' })
export class PurchasesMockApi implements PurchasesApiModel {
  constructor(private demoSettingsStore: DemoSettingsStore) {}

  getViCarePlans(_installationId: number): Observable<ViCarePlan[]> {
    return of(new MockedVicarePlans().mock());
  }
  getAvailablePaidFeaturesForSingleInstallation(
    _scope: PaidFeatureScope,
    id: string
  ): Observable<SubscriptionWithPaidFeatures[]> {
    return this.demoSettingsStore.getSubscriptionForResourceId(id);
  }

  getUserSubscriptionFeatures(_userId: number): Observable<ViCarePlan[]> {
    return of([]);
  }
}
